import { UserIndustry } from '@common/onboarding/userConstants';
import { Entity } from '@common/types/Entity';
import { getSqlIDEUrl } from '@common/url';
import { theme } from '@prophecy/theme';
import { Stack, Text, Ellipsis, Button } from '@prophecy/ui-v3';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { PackageCard } from '../components/PackageCard';
import { ListRoot } from '../package-list';
import { TemplateType } from '../types';

export const TemplateList = ({ templates }: { templates: TemplateType[] }) => {
  const selectedPackages: string[] = [];
  const navigate = useNavigate();
  const [currentProjectView, setCurrentProjectView] = useState('');

  return (
    <Stack width='100%' height='100%' gap={theme.spaces.x32}>
      {templates.length === 0 ? (
        <Text level='sm' tone={theme.colors.gray500}>
          No templates found.
        </Text>
      ) : null}

      {templates.map((item) => {
        const {
          _id,
          language,
          name,
          industry = UserIndustry.OTHER,
          description,
          sqlOrchestratorPipelines: pipelines = []
        } = item;
        //Return only selected project pipelines list in the view
        if (currentProjectView && name !== currentProjectView) {
          return null;
        }
        const selected = selectedPackages.includes(_id);
        const hasMorePipelines = pipelines.length > 4;
        return (
          <Stack key={_id} width='100%' gap={theme.spaces.x24}>
            <Stack direction='horizontal' width='100%' height='100%' align='space-between' gap={theme.spaces.x24}>
              <Text level='lg' weight={theme.fontWeight.semiBold} tone={theme.colors.gray900}>
                <Ellipsis tooltip={true}>{industry} Pipeline Templates</Ellipsis>
              </Text>
              {hasMorePipelines && (
                <Button
                  size='s'
                  variant='link'
                  onClick={() => setCurrentProjectView(currentProjectView ? '' : name)}
                  data-test-id='template-list-view-all-button'>
                  {currentProjectView ? 'Back' : 'View all'}
                </Button>
              )}
            </Stack>

            <ListRoot>
              {pipelines.map((pipeline, i) => {
                if (i > 3 && !currentProjectView) {
                  return null;
                }
                return (
                  <PackageCard
                    selected={selected}
                    key={pipeline._id}
                    description={pipeline.description || description}
                    language={language}
                    title={pipeline.name}
                    industry={industry}
                    pipelines={pipelines}
                    onClick={() => navigate(getSqlIDEUrl({ uid: _id, entity: Entity.Pipeline, name: pipeline.name }))}
                  />
                );
              })}
            </ListRoot>
          </Stack>
        );
      })}
    </Stack>
  );
};
